var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgScienceImgTwo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 916.903,
    height: 915,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2703",
    d: "M692.9 1268.51a36.676 36.676 0 1 0 36.676 36.676 36.676 36.676 0 0 0-36.676-36.676Zm0 57.571a20.9 20.9 0 1 1 20.9-20.9 20.9 20.9 0 0 1-20.9 20.9Z",
    transform: "translate(-656.223 -1268.51)",
    fill: "#fff",
    opacity: 0.57
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "b"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2705",
    d: "M1072.723 1268.51a36.676 36.676 0 1 0 36.676 36.676 36.676 36.676 0 0 0-36.676-36.676Zm0 57.571a20.9 20.9 0 1 1 20.9-20.9 20.9 20.9 0 0 1-20.9 20.9Z",
    transform: "translate(-1036.047 -1268.51)",
    fill: "#fff",
    opacity: 0.57
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "c"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2707",
    d: "M1452.546 1268.51a36.676 36.676 0 1 0 36.676 36.676 36.676 36.676 0 0 0-36.676-36.676Zm0 57.571a20.9 20.9 0 1 1 20.9-20.9 20.9 20.9 0 0 1-20.9 20.9Z",
    transform: "translate(-1415.87 -1268.51)",
    fill: "#fff",
    opacity: 0.57
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 3467"
  }, /*#__PURE__*/React.createElement("circle", {
    "data-name": "Ellipse 24",
    cx: 457.5,
    cy: 457.5,
    r: 457.5,
    transform: "translate(1.903)",
    fill: "#f5f8fe",
    opacity: 0.9
  }), /*#__PURE__*/React.createElement("g", {
    "data-name": "Background",
    transform: "translate(80.362 78.46)"
  }, /*#__PURE__*/React.createElement("circle", {
    "data-name": "Ellipse 24",
    cx: 379.5,
    cy: 379.5,
    r: 379.5,
    transform: "translate(-.46 -.459)",
    fill: "none",
    stroke: "#cbcbd9"
  })), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 3420"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 3392"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 3386"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 3382",
    opacity: 0.3,
    fill: "#c8d1e3"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2679",
    d: "M171.666 183.948a2.387 2.387 0 0 1-3.279-.808 91.081 91.081 0 0 0-4.282-6.443 2.388 2.388 0 0 1 .489-3.308l.037-.028a2.388 2.388 0 0 1 3.336.526 95.82 95.82 0 0 1 4.507 6.782 2.388 2.388 0 0 1-.6 3.137 2.292 2.292 0 0 1-.208.142Zm-15.633-16.882a91.15 91.15 0 0 0-5.592-5.342 2.388 2.388 0 1 1 3.149-3.59 96.25 96.25 0 0 1 5.885 5.621 2.388 2.388 0 0 1-.066 3.377 2.462 2.462 0 0 1-.216.184 2.388 2.388 0 0 1-3.16-.251Zm-15.587-12.947a89.976 89.976 0 0 0-6.642-3.958 2.388 2.388 0 1 1 2.266-4.2 94.933 94.933 0 0 1 6.994 4.169 2.388 2.388 0 1 1-2.619 3.993Zm-18.092-9.135a90.4 90.4 0 0 0-7.362-2.376 2.388 2.388 0 0 1 1.271-4.6 96.736 96.736 0 0 1 7.751 2.5 2.388 2.388 0 0 1-1.659 4.479Zm-19.676-4.877a91.677 91.677 0 0 0-7.706-.686 2.388 2.388 0 1 1 .223-4.77c2.7.126 5.433.369 8.108.722a2.388 2.388 0 1 1-.625 4.734Zm-20.264-.4a91.185 91.185 0 0 0-7.665 1.036 2.388 2.388 0 0 1-.84-4.7 96.094 96.094 0 0 1 8.067-1.09 2.388 2.388 0 0 1 .438 4.756ZM7.867 187.722a2.388 2.388 0 0 1-.963-3.237 94.521 94.521 0 0 1 4.184-6.989 2.388 2.388 0 0 1 3.988 2.626 90.25 90.25 0 0 0-3.972 6.637 2.385 2.385 0 0 1-3.237.963Zm54.709-43.917c-2.44.8-4.874 1.711-7.236 2.716a2.39 2.39 0 1 1-1.869-4.4 94.85 94.85 0 0 1 7.62-2.86 2.388 2.388 0 1 1 1.484 4.539Zm-43.245 26.543a2.388 2.388 0 0 1-.214-3.37c1.785-2.027 3.682-4 5.636-5.877a2.388 2.388 0 0 1 3.3 3.449 91.62 91.62 0 0 0-5.356 5.585 2.39 2.39 0 0 1-3.37.213Zm24.825-18.121a90.897 90.897 0 0 0-6.45 4.266 2.388 2.388 0 0 1-2.843-3.836l.041-.03a95.545 95.545 0 0 1 6.789-4.493 2.388 2.388 0 0 1 2.676 3.948c-.068.055-.143.103-.213.148Z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2680",
    d: "M3.832 202.931a2.373 2.373 0 0 0 .827-1.162 92.01 92.01 0 0 1 1.225-3.514 2.388 2.388 0 1 0-4.476-1.662 94.702 94.702 0 0 0-1.289 3.7 2.388 2.388 0 0 0 3.714 2.642Z"
  })), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 3383",
    opacity: 0.3,
    fill: "#c8d1e3"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2681",
    d: "M10.098 275.461a2.389 2.389 0 0 0 .664-3.024 87.386 87.386 0 0 1-1.681-3.32 2.388 2.388 0 1 0-4.3 2.069 100.555 100.555 0 0 0 1.77 3.5 2.388 2.388 0 0 0 3.23.986 2.451 2.451 0 0 0 .317-.211Z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2682",
    d: "M144.47 308.758a2.388 2.388 0 1 1-2.693-3.944 91.512 91.512 0 0 0 6.1-4.552 2.388 2.388 0 0 1 3.01 3.709q-1.29 1.047-2.6 2.042a94.94 94.94 0 0 1-3.817 2.745Zm12.57-13.547a2.387 2.387 0 0 1-.108-3.375 92.908 92.908 0 0 0 4.971-5.766 2.388 2.388 0 1 1 3.745 2.963 95.974 95.974 0 0 1-5.232 6.069 2.414 2.414 0 0 1-.3.272 2.388 2.388 0 0 1-3.074-.159Zm-23.792 20.131a95.383 95.383 0 0 1-7.316 3.265 2.388 2.388 0 1 1-1.76-4.44 90.142 90.142 0 0 0 6.948-3.1 2.388 2.388 0 0 1 2.129 4.275Zm36.489-36.2a2.388 2.388 0 0 1-.847-3.269 90.501 90.501 0 0 0 3.579-6.715 2.388 2.388 0 0 1 4.305 2.065 94.982 94.982 0 0 1-3.769 7.072 2.385 2.385 0 0 1-3.269.847Zm-56.194 43.415a95.018 95.018 0 0 1-7.853 1.575 2.388 2.388 0 1 1-.742-4.717c2.5-.393 5.01-.9 7.458-1.5a2.388 2.388 0 1 1 1.136 4.639Zm-20.809 2.718a96.758 96.758 0 0 1-8.008-.174 2.388 2.388 0 1 1 .3-4.766c2.52.16 5.081.216 7.609.166a2.387 2.387 0 1 1 .095 4.774Zm-20.908-1.881a96.452 96.452 0 0 1-7.779-1.915 2.388 2.388 0 1 1 1.334-4.586 91.178 91.178 0 0 0 7.392 1.819 2.388 2.388 0 0 1-.947 4.681Zm-20-6.4a95.037 95.037 0 0 1-7.173-3.575 2.388 2.388 0 1 1 2.309-4.18 89.615 89.615 0 0 0 6.812 3.394 2.388 2.388 0 1 1-1.948 4.36Zm-18.114-10.641a95.274 95.274 0 0 1-6.205-5.064 2.388 2.388 0 1 1 3.172-3.57 89.64 89.64 0 0 0 5.894 4.81 2.388 2.388 0 1 1-2.861 3.823Zm-15.32-14.344a97.187 97.187 0 0 1-3.7-4.587q-.641-.846-1.26-1.7a2.361 2.361 0 0 1 .535-3.334 2.388 2.388 0 0 1 3.334.535q.588.813 1.2 1.618a90.306 90.306 0 0 0 3.516 4.361 2.387 2.387 0 0 1-.257 3.367 3.339 3.339 0 0 1-.115.093 2.388 2.388 0 0 1-3.25-.347Z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2683",
    d: "M180.776 260.247a2.38 2.38 0 0 0 .832-1.174c.394-1.231.77-2.494 1.117-3.753a2.388 2.388 0 0 0-4.6-1.268c-.33 1.2-.687 2.4-1.061 3.565a2.387 2.387 0 0 0 3.716 2.631Z"
  })), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 3385"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2684",
    d: "M162.079 223.832a1.116 1.116 0 0 0-.714-1.082l-12.667-4.894a59.178 59.178 0 0 0-6.682-17.968l6.384-11.979a1.116 1.116 0 0 0-.167-1.285l-11.1-11.931a1.115 1.115 0 0 0-1.269-.261l-12.411 5.5a59.169 59.169 0 0 0-17.436-7.968l-3.959-12.993a1.116 1.116 0 0 0-1.027-.79l-16.282-.592a1.116 1.116 0 0 0-1.082.714l-4.891 12.672a59.156 59.156 0 0 0-17.968 6.682l-11.979-6.384a1.116 1.116 0 0 0-1.285.168l-11.932 11.091a1.116 1.116 0 0 0-.26 1.269l5.5 12.411a59.156 59.156 0 0 0-7.968 17.436l-12.993 3.959a1.115 1.115 0 0 0-.793 1.025l-.592 16.282a1.116 1.116 0 0 0 .713 1.081l12.672 4.891a59.154 59.154 0 0 0 6.682 17.968l-6.384 11.979a1.116 1.116 0 0 0 .167 1.285l11.1 11.932a1.116 1.116 0 0 0 1.269.26l12.411-5.5a59.169 59.169 0 0 0 17.436 7.968l3.959 12.993a1.116 1.116 0 0 0 1.027.79l16.282.591a1.116 1.116 0 0 0 1.082-.713l4.891-12.672a59.173 59.173 0 0 0 17.968-6.682l11.979 6.384a1.117 1.117 0 0 0 1.285-.168l11.932-11.1a1.116 1.116 0 0 0 .26-1.269l-5.5-12.411a59.171 59.171 0 0 0 7.968-17.436l12.993-3.959a1.116 1.116 0 0 0 .79-1.027Z",
    fill: "#e0e7f5"
  }), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 3384"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2685",
    d: "M98.171 243.736a16.368 16.368 0 1 1 2.019-1.308 16.4 16.4 0 0 1-2.019 1.308ZM78.237 225.86a12.557 12.557 0 1 0 6.015-7.5 12.743 12.743 0 0 0-1.563 1.013 12.465 12.465 0 0 0-4.452 6.487Z",
    fill: "#c8d1e3"
  })), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2686",
    d: "M114.203 261.483a40.983 40.983 0 0 0 3.169-2.662q.481-.446.947-.909a40.532 40.532 0 0 0 4.2-4.891l.052-.071c.049-.067.1-.134.145-.2.094-.131.187-.263.28-.4a.955.955 0 0 0-.021-1.123.966.966 0 0 0-.216-.207.956.956 0 0 0-1.329.237 38.4 38.4 0 0 1-41.186 15.172 38.121 38.121 0 0 1-18.388-10.98 38.925 38.925 0 0 1-2.539-3.023 38.361 38.361 0 0 1 58.72-49.22 38.369 38.369 0 0 1 9.432 18.126.955.955 0 1 0 1.868-.4 40.273 40.273 0 1 0-71.547 32.641 41.152 41.152 0 0 0 2.665 3.173 40.277 40.277 0 0 0 53.743 4.73Z",
    fill: "#c8d1e3"
  }))), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 3391"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 3387",
    opacity: 0.3,
    fill: "#c8d1e3"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2687",
    d: "M274.823 184.781a1.474 1.474 0 0 0 .488-1.7 63.766 63.766 0 0 0-1.443-3.487 1.475 1.475 0 0 0-2.69 1.21c.49 1.089.953 2.207 1.376 3.324a1.476 1.476 0 0 0 1.9.856 1.5 1.5 0 0 0 .369-.203Z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2688",
    d: "M269.718 174.67a1.475 1.475 0 0 1-2.026-.494 61.271 61.271 0 0 0-3.481-5.116q-.392-.518-.8-1.031a1.476 1.476 0 0 1 .242-2.072 1.527 1.527 0 0 1 2.072.243q.425.537.836 1.08a63.954 63.954 0 0 1 3.649 5.365 1.474 1.474 0 0 1-.368 1.941 3.333 3.333 0 0 1-.124.084Zm-11.3-12.223a61.084 61.084 0 0 0-5.637-4.929 1.475 1.475 0 0 1 1.8-2.336 63.9 63.9 0 0 1 5.91 5.167 1.476 1.476 0 0 1 .012 2.087 1.536 1.536 0 0 1-.16.139 1.475 1.475 0 0 1-1.927-.128Zm-11.843-9.123a60.509 60.509 0 0 0-6.677-3.393 1.475 1.475 0 0 1 1.171-2.708 63.6 63.6 0 0 1 7 3.558 1.476 1.476 0 0 1-1.5 2.542Zm-13.723-5.934a60.834 60.834 0 0 0-7.3-1.655 1.475 1.475 0 0 1 .472-2.912 63.926 63.926 0 0 1 7.659 1.736 1.475 1.475 0 0 1-.828 2.831Zm-14.756-2.4a61.412 61.412 0 0 0-7.486.168 1.475 1.475 0 1 1-.246-2.939 64.536 64.536 0 0 1 7.846-.177 1.475 1.475 0 0 1-.114 2.948Zm-14.892 1.251a60.5 60.5 0 0 0-7.212 1.987 1.475 1.475 0 0 1-.959-2.79 63.487 63.487 0 0 1 7.565-2.084 1.475 1.475 0 0 1 .605 2.887Zm-14.128 4.853a60.6 60.6 0 0 0-6.509 3.7 1.476 1.476 0 0 1-1.613-2.471 64.008 64.008 0 0 1 6.825-3.879 1.475 1.475 0 0 1 1.54 2.5 1.5 1.5 0 0 1-.245.145Zm-20.015 13.43a1.474 1.474 0 0 1-.08-2.084 64.145 64.145 0 0 1 4.9-4.749c.259-.229.521-.452.784-.675a1.475 1.475 0 0 1 1.9 2.257c-.248.208-.493.419-.741.637a61.124 61.124 0 0 0-4.676 4.534 1.441 1.441 0 0 1-.193.175 1.475 1.475 0 0 1-1.896-.101Z"
  })), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 3388",
    opacity: 0.3,
    fill: "#c8d1e3"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2689",
    d: "M253.49 256.998a64.174 64.174 0 0 1-6.48 4.2 1.475 1.475 0 1 1-1.451-2.569 60.968 60.968 0 0 0 6.181-4 1.475 1.475 0 0 1 1.766 2.363Zm3.847-5.012a1.474 1.474 0 0 1 .063-2.084 61.681 61.681 0 0 0 5.053-5.364 1.475 1.475 0 0 1 2.265 1.891 64.52 64.52 0 0 1-5.3 5.621 1.475 1.475 0 0 1-2.085-.063Zm-17.274 12.59a63.977 63.977 0 0 1-7.3 2.507 1.475 1.475 0 0 1-.787-2.844 61.148 61.148 0 0 0 6.969-2.39 1.475 1.475 0 1 1 1.123 2.727Zm27.2-23.933a1.475 1.475 0 0 1-.44-2.039 60.583 60.583 0 0 0 3.608-6.423 1.475 1.475 0 1 1 2.655 1.284 63.279 63.279 0 0 1-3.784 6.737 1.475 1.475 0 0 1-2.039.44Zm-42.06 28.039a64.107 64.107 0 0 1-7.692.676 1.475 1.475 0 1 1-.08-2.949 60.708 60.708 0 0 0 7.336-.645 1.475 1.475 0 0 1 .436 2.918Zm-15.409.423a64.492 64.492 0 0 1-7.632-1.183 1.474 1.474 0 1 1 .627-2.881 61.714 61.714 0 0 0 7.281 1.127 1.475 1.475 0 0 1-.276 2.937Zm-15.068-3.279a63.727 63.727 0 0 1-7.128-2.981 1.475 1.475 0 0 1 1.3-2.647 60.364 60.364 0 0 0 6.8 2.842 1.474 1.474 0 0 1 .907 1.878 1.458 1.458 0 0 1-.5.69 1.475 1.475 0 0 1-1.375.222Z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2690",
    d: "M275.534 226.954a1.467 1.467 0 0 0 .505-.7c.407-1.2.779-2.408 1.109-3.6a1.476 1.476 0 0 0-2.845-.784c-.314 1.141-.67 2.3-1.057 3.438a1.475 1.475 0 0 0 2.288 1.649Z"
  })), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 3390"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2691",
    d: "M263.45 201.609a.747.747 0 0 0-.477-.724l-8.48-3.273a39.591 39.591 0 0 0-4.471-12.023l4.272-8.016a.746.746 0 0 0-.112-.86l-7.424-7.984a.746.746 0 0 0-.849-.174l-8.3 3.679a39.587 39.587 0 0 0-11.667-5.332l-2.649-8.694a.747.747 0 0 0-.687-.529l-10.9-.4a.747.747 0 0 0-.724.478l-3.273 8.479a39.581 39.581 0 0 0-12.023 4.471l-8.016-4.272a.747.747 0 0 0-.86.112l-7.984 7.424a.746.746 0 0 0-.174.849l3.679 8.3a39.589 39.589 0 0 0-5.332 11.667l-8.695 2.649a.747.747 0 0 0-.529.687l-.4 10.9a.747.747 0 0 0 .477.724l8.48 3.273a39.581 39.581 0 0 0 4.471 12.023l-4.272 8.016a.746.746 0 0 0 .112.86l7.424 7.984a.747.747 0 0 0 .849.174l8.305-3.679a39.586 39.586 0 0 0 11.667 5.332l2.649 8.695a.747.747 0 0 0 .687.529l10.9.4a.747.747 0 0 0 .724-.477l3.273-8.48a39.59 39.59 0 0 0 12.023-4.471l8.016 4.272a.747.747 0 0 0 .86-.112l7.984-7.424a.746.746 0 0 0 .174-.849l-3.679-8.3a39.6 39.6 0 0 0 5.332-11.667l8.695-2.649a.747.747 0 0 0 .529-.687Z",
    fill: "#e0e7f5"
  }), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 3389"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2692",
    d: "M220.781 215.098a11.12 11.12 0 1 1 1.388-.9 11.4 11.4 0 0 1-1.388.9Zm-12.561-5.833a8.206 8.206 0 0 0 11.142 3.248 8.207 8.207 0 0 0-7.894-14.39 8.341 8.341 0 0 0-1.011.656 8.22 8.22 0 0 0-2.237 10.486Z",
    fill: "#c8d1e3"
  })), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2693",
    d: "M231.94 227.454a28.249 28.249 0 0 0 2.163-1.817 27.948 27.948 0 0 0 3.735-4.254l.146-.208a1.475 1.475 0 1 0-2.418-1.688 24.9 24.9 0 0 1-3.47 3.989c-.071.066-.143.132-.214.2a24.59 24.59 0 0 1-10.724 5.735 24.97 24.97 0 0 1-6.649.708h-.055l-.169-.006a24.672 24.672 0 0 1-17.284-7.906 25.144 25.144 0 0 1-1.644-1.956 24.834 24.834 0 1 1 44.12-20.13 1.476 1.476 0 0 0 1.749 1.136 1.476 1.476 0 0 0 1.136-1.75 27.784 27.784 0 1 0-49.36 22.52 28.4 28.4 0 0 0 1.838 2.189 27.823 27.823 0 0 0 37.1 3.238Z",
    fill: "#c8d1e3"
  })))), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 3414"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 3393"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2694",
    d: "m360.799 609.378-14.413 99.465h167.219l-21.778-99.465Z",
    fill: "#b8c3d9"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2695",
    d: "M79.902 290.902v296.049a44.91 44.91 0 0 0 43.753 44.9c108.131 2.788 486.323 9.55 589.257 8.032a33.046 33.046 0 0 0 32.534-32.1c1.985-68.776 5.208-234.16-6.721-310.941a34.006 34.006 0 0 0-32.516-28.783c-90.6-2.9-491.508-12.1-594.394-9.791a32.643 32.643 0 0 0-31.913 32.634Z",
    fill: "#b8c3d9"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2696",
    d: "M98.478 289.46v281.267a26.021 26.021 0 0 0 25.632 26.018l573.993 7.091a25.324 25.324 0 0 0 25.7-25.227l.96-278.753a18.52 18.52 0 0 0-18.07-18.584l-587.66-11.873a20.067 20.067 0 0 0-20.555 20.061Z",
    fill: "#e0e7f5"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2697",
    d: "M728.127 615.363h-.014L98.465 604.634a.8.8 0 0 1-.782-.809.808.808 0 0 1 .81-.782l629.648 10.728a.8.8 0 0 1-.013 1.592Z",
    fill: "#d6d6d6"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2698",
    d: "M419.514 628.467a7.347 7.347 0 1 1 7.347-7.348 7.356 7.356 0 0 1-7.347 7.348Zm0-13.1a5.755 5.755 0 1 0 5.755 5.755 5.761 5.761 0 0 0-5.755-5.758Z",
    fill: "#d6d6d6"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2699",
    d: "M549.626 735.294H304.888c-6.649 0-11.641-4.733-10.356-9.817l3.141-12.42c.944-3.735 5.053-6.477 9.934-6.629l235.934-7.362c5.1-.159 9.614 2.548 10.724 6.429l5.661 19.782c1.471 5.138-3.546 10.017-10.3 10.017Z",
    fill: "#b8c3d9"
  })), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 3395"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 3394",
    opacity: 0.53,
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle 1489",
    d: "M417.139 309.121h15.097v266.284h-15.097z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle 1490",
    d: "M442.365 309.121h15.097v266.284h-15.097z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle 1491",
    d: "M467.59 309.121h15.097v266.284H467.59z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle 1492",
    d: "M492.816 309.121h15.097v266.284h-15.097z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle 1493",
    d: "M518.042 309.121h15.097v266.284h-15.097z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle 1494",
    d: "M543.268 309.121h15.097v266.284h-15.097z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle 1495",
    d: "M568.493 309.121h15.097v266.284h-15.097z"
  })), /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle 1496",
    fill: "#207bbd",
    d: "M417.139 436.048h15.097v139.357h-15.097z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle 1497",
    fill: "#207bbd",
    d: "M442.365 483.943h15.097v91.462h-15.097z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle 1498",
    fill: "#207bbd",
    d: "M467.59 365.575h15.097v209.831H467.59z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle 1499",
    fill: "#207bbd",
    d: "M492.816 524.996h15.097v50.409h-15.097z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle 1500",
    fill: "#207bbd",
    d: "M518.042 393.627h15.097v181.778h-15.097z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle 1501",
    fill: "#207bbd",
    d: "M543.268 425.101h15.097v150.304h-15.097z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle 1502",
    fill: "#207bbd",
    d: "M568.493 459.312h15.097v116.094h-15.097z"
  })), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 3405"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 3398"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 3397"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2702",
    d: "M168.147 296.954a36.676 36.676 0 1 0 36.676 36.676 36.676 36.676 0 0 0-36.676-36.676Zm0 57.571a20.9 20.9 0 1 1 20.9-20.9 20.9 20.9 0 0 1-20.9 20.9Z",
    fill: "#fff",
    opacity: 0.57
  }), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 3396",
    clipPath: "url(#a)",
    transform: "translate(131.47 296.954)"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle 1503",
    fill: "#69d2c9",
    d: "M36.676-7.39h57.728v82.105H36.676z"
  })))), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 3401"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 3400"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2704",
    d: "M257.551 296.954a36.676 36.676 0 1 0 36.676 36.676 36.676 36.676 0 0 0-36.676-36.676Zm0 57.571a20.9 20.9 0 1 1 20.9-20.9 20.9 20.9 0 0 1-20.9 20.9Z",
    fill: "#fff",
    opacity: 0.57
  }), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 3399",
    clipPath: "url(#b)",
    transform: "translate(220.875 296.954)"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle 1504",
    fill: "#207bbd",
    d: "M36.676-16.211h57.728v63.926H36.676z"
  })))), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 3404"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 3403"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2706",
    d: "M346.957 296.954a36.676 36.676 0 1 0 36.676 36.676 36.676 36.676 0 0 0-36.676-36.676Zm0 57.571a20.9 20.9 0 1 1 20.9-20.9 20.9 20.9 0 0 1-20.9 20.9Z",
    fill: "#fff",
    opacity: 0.57
  }), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 3402",
    clipPath: "url(#c)",
    transform: "translate(310.281 296.954)"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle 1505",
    fill: "#1f161e",
    d: "M44.459-4.337h49.946v36.053H44.459z"
  }))))), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 3406",
    transform: "translate(131.47 437.339)"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2708",
    d: "M243.651 139.54 8.386 137.773a8.449 8.449 0 0 1-8.385-8.449V8.449A8.449 8.449 0 0 1 8.45 0h235.264a8.449 8.449 0 0 1 8.449 8.449v122.639a8.449 8.449 0 0 1-8.512 8.452Z",
    fill: "none",
    stroke: "#c8d1e3"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2709",
    d: "M207.159 54.575 176.906 22.59l-43.378 47.18-30.608-33.026-28.706 32.451-22.013-26.744L8.818 87.618v32.662a7.858 7.858 0 0 0 7.8 7.858l218.813 1.644a7.858 7.858 0 0 0 7.917-7.858V33.068Z",
    fill: "#fff",
    opacity: 0.44
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle 1506",
    fill: "#fff",
    d: "M207.344 53.685h.796v76.097h-.796z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle 1507",
    fill: "#fff",
    d: "M176.508 22.59h.796v106.752h-.796z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle 1508",
    fill: "#fff",
    d: "M133.13 69.195h.796v59.822h-.796z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle 1509",
    fill: "#fff",
    d: "M103.335 37.914h.796v91.103h-.796z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle 1510",
    fill: "#fff",
    d: "M73.816 68.225h.796v60.792h-.796z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle 1511",
    fill: "#fff",
    d: "M52.269 40.182h.796v88.251h-.796z"
  }), /*#__PURE__*/React.createElement("circle", {
    "data-name": "Ellipse 165",
    cx: 6.648,
    cy: 6.648,
    r: 6.648,
    transform: "rotate(-67.5 54.751 -11.021)",
    fill: "#69d2c9"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2710",
    d: "M78.592 68.225a4.379 4.379 0 1 1-4.379-4.379 4.379 4.379 0 0 1 4.379 4.379Z",
    fill: "#69d2c9"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2711",
    d: "M108.112 37.914a4.379 4.379 0 1 1-4.379-4.379 4.379 4.379 0 0 1 4.379 4.379Z",
    fill: "#69d2c9"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2712",
    d: "M137.907 69.194a4.379 4.379 0 1 1-4.379-4.379 4.379 4.379 0 0 1 4.379 4.379Z",
    fill: "#69d2c9"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2713",
    d: "M181.285 22.59a4.379 4.379 0 1 1-4.379-4.379 4.379 4.379 0 0 1 4.379 4.379Z",
    fill: "#69d2c9"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2714",
    d: "M212.12 53.686a4.379 4.379 0 1 1-4.379-4.379 4.379 4.379 0 0 1 4.379 4.379Z",
    fill: "#207bbd"
  })), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 3407",
    opacity: 0.48,
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2715",
    d: "M199.449 417.215h-64.492c-2.7 0-4.885 1.523-4.885 3.4s2.187 3.4 4.885 3.4h64.493c2.7 0 4.885-1.523 4.885-3.4s-2.188-3.4-4.886-3.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2716",
    d: "M199.449 402.152h-64.492c-2.7 0-4.885 1.523-4.885 3.4s2.187 3.4 4.885 3.4h64.493c2.7 0 4.885-1.523 4.885-3.4s-2.188-3.4-4.886-3.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2717",
    d: "M199.449 387.089h-64.492c-2.7 0-4.885 1.523-4.885 3.4s2.187 3.4 4.885 3.4h64.493c2.7 0 4.885-1.523 4.885-3.4s-2.188-3.4-4.886-3.4Z"
  })), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 3408",
    opacity: 0.48,
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2718",
    d: "M289.099 417.215h-64.493c-2.7 0-4.885 1.523-4.885 3.4s2.187 3.4 4.885 3.4h64.493c2.7 0 4.885-1.523 4.885-3.4s-2.187-3.4-4.885-3.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2719",
    d: "M289.099 402.152h-64.493c-2.7 0-4.885 1.523-4.885 3.4s2.187 3.4 4.885 3.4h64.493c2.7 0 4.885-1.523 4.885-3.4s-2.187-3.4-4.885-3.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2720",
    d: "M289.099 387.089h-64.493c-2.7 0-4.885 1.523-4.885 3.4s2.187 3.4 4.885 3.4h64.493c2.7 0 4.885-1.523 4.885-3.4s-2.187-3.4-4.885-3.4Z"
  })), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 3409",
    opacity: 0.48,
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2721",
    d: "M378.748 417.215h-64.493c-2.7 0-4.885 1.523-4.885 3.4s2.187 3.4 4.885 3.4h64.493c2.7 0 4.885-1.523 4.885-3.4s-2.188-3.4-4.885-3.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2722",
    d: "M378.748 402.152h-64.493c-2.7 0-4.885 1.523-4.885 3.4s2.187 3.4 4.885 3.4h64.493c2.7 0 4.885-1.523 4.885-3.4s-2.188-3.4-4.885-3.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2723",
    d: "M378.748 387.089h-64.493c-2.7 0-4.885 1.523-4.885 3.4s2.187 3.4 4.885 3.4h64.493c2.7 0 4.885-1.523 4.885-3.4s-2.188-3.4-4.885-3.4Z"
  })), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 3413"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 3410",
    transform: "translate(609.41 389.169)"
  }, /*#__PURE__*/React.createElement("circle", {
    "data-name": "Ellipse 166",
    cx: 29.841,
    cy: 29.841,
    r: 29.841,
    transform: "translate(12.361 12.361)",
    fill: "#fcfdfe"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2724",
    d: "M59.934 35.896a19.169 19.169 0 1 1-17.732-11.885q.487 0 .967.025v-4.859a25.855 25.855 0 0 0-.967-.021 24.007 24.007 0 1 0 22.189 14.8Z",
    fill: "#1f161e"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2725",
    d: "M66.73 84.685H18.101a5.527 5.527 0 1 0 0 11.054H66.73a5.527 5.527 0 1 0 0-11.054Z",
    fill: "#fff",
    opacity: 0.5
  })), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 3411",
    transform: "translate(609.282 293.256)"
  }, /*#__PURE__*/React.createElement("circle", {
    "data-name": "Ellipse 167",
    cx: 29.841,
    cy: 29.841,
    r: 29.841,
    transform: "translate(12.361 12.361)",
    fill: "#fcfdfe"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2726",
    d: "M52.349 59.396a19.167 19.167 0 1 1-10.213-35.385c.324 0 .646.009.967.025v-4.857a23.876 23.876 0 0 0-.967-.021 24.023 24.023 0 1 0 12.622 44.466Z",
    fill: "#207bbd"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2727",
    d: "M66.986 84.685H18.357a5.527 5.527 0 1 0 0 11.053h48.629a5.527 5.527 0 1 0 0-11.053Z",
    fill: "#fff",
    opacity: 0.5
  })), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 3412",
    transform: "translate(609.517 485.571)"
  }, /*#__PURE__*/React.createElement("circle", {
    "data-name": "Ellipse 168",
    cx: 29.841,
    cy: 29.841,
    r: 29.841,
    transform: "translate(12.361 12.361)",
    fill: "#fff",
    opacity: 0.91
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2728",
    d: "M58.454 52.979a19.168 19.168 0 1 1-15.852-29.945c.324 0 .646.009.967.024v-4.859a23.876 23.876 0 0 0-.967-.021 24.023 24.023 0 1 0 19.786 37.649Z",
    fill: "#69d2c9"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2729",
    d: "M17.888 94.761h48.63a5.527 5.527 0 0 0 0-11.054h-48.63a5.527 5.527 0 1 0 0 11.054Z",
    fill: "#fff",
    opacity: 0.5
  }))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgScienceImgTwo);
export default __webpack_public_path__ + "static/media/science-img-two.8e45824215e7e3204f248fe63fc08933.svg";
export { ForwardRef as ReactComponent };